export const LIB_VERSION = '17.0.0'; // autogenerated
//# sourceMappingURL=version.js.map